//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import VirtualScroll from '../../../../components/virtual-scroll/index.js';
import VirtualScrollArea from './virtualScrollArea';

Vue.component('VirtualScrollArea', VirtualScrollArea);

export default {
  extends: VirtualScroll,
};
